<template>

<component-module moduleName="orders_sales_module">
    <template v-slot:programName>Orders &amp; Sales</template>
    <template v-slot:navigation>
        <div class="main-nav">
            <template v-if="dashboardMenuItem">
                <div v-if="dashboardMenuItem.not_allowed" class="not-allowed">Dashboard</div>
                <router-link v-else class="link" :to="'/' + dashboardMenuItem.link_value">Dashboard</router-link>
            </template>
            <template v-for="(menuItem, index) in mainMenu">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub_menu_item_' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
            <router-link to="/help-center/articles/4" class="link menu-nav-extra">Help Center <i class="fa fa-chevron-right" /> Orders & Sales</router-link>
        </div>
    </template>
</component-module>

</template>

<script>
import './orders-sales.scss'
export default {
    data() {
        return {
        }
    },
    created() {
        this.updateCustomModuleName('Orders & Sales');
    },
    computed: {
        mainMenu() {
            if (!this.getModuleNavMenu) return {}
            return this.getModuleNavMenu
        },
        dashboardMenuItem() {
            for (const [key, menuItem] of Object.entries(this.getFlightDeckMainMenu)) {
                if (menuItem.link_value == 'orders-sales') {
                    return menuItem
                }
            }
        }
    }
}
</script>
